import { queryOptions } from '@tanstack/react-query'
import {
  type GetAssetDataRequest,
  getAssetData,
} from '@/src/services/token-info/asset-data'

const ASSET_DATA_BASE_KEY = 'token-info-asset-data'

export const assetDataQuery = (req: GetAssetDataRequest) =>
  queryOptions({
    queryKey: [ASSET_DATA_BASE_KEY, req.chainId, req.denom],
    queryFn: () => getAssetData(req),
    staleTime: 60 * 1000, // 1 minute since prices are involved
    placeholderData: (previousData) => previousData, // Keep previous token data visible while new token loads
  })
